// Domain-level enums live in @/enums (see ObjectiveBasedCampaignType,
// PaymentRestriction, MilestoneType, MilestoneRewardType). Re-exported here
// so existing callers can keep their current import path.

export {
  MilestoneRewardType,
  MilestoneType,
  ObjectiveBasedCampaignType,
  PaymentRestriction,
} from '@/enums';

import type {
  MilestoneRewardType,
  MilestoneType,
  ObjectiveBasedCampaignType,
  PaymentRestriction,
} from '@/enums';

export interface ObjectiveBasedCampaignDto {
  DiscountId: string | null;
  DiscountName: string;
  CampaignType: ObjectiveBasedCampaignType;
  StartDateUtc: string;
  EndDateUtc: string;
  IsEnabled: boolean;
  PaymentRestriction: PaymentRestriction;
  AllowGuestUsers: boolean;
  IsAchieved: boolean;
  RuleDetails: unknown;
  ClaimButtonEnabled?: boolean;
}

// Single source of truth for the checkout banner copy. The JSX never contains
// the literal string — it always renders `OfferNoticeText.EligibleForDiscountOffer`.
export enum OfferNoticeText {
  EligibleForDiscountOffer =
    "You're eligible for a discount offer. To claim this offer, complete your payment {0}.",
}

// ─── Milestone (mirrors BE MilestoneDetailDto at HEAD) ────────────────────

export interface IMilestoneDetail {
  Name: string;
  MilestoneType: MilestoneType;
  TargetValue: number;
  RewardType: MilestoneRewardType;
  RewardValue: number;
  RequiredPurchaseCount: number | null;
  RequiredPurchaseAmount: number | null;
  CurrentPurchaseCount: number | null;
  RemainingPurchaseCount: number | null;
  CurrentPurchaseAmount: number | null;
  RemainingPurchaseAmount: number | null;
}

export interface IMilestoneRuleDetails {
  Milestones: IMilestoneDetail[];
}